export default __webpack_public_path__ + "static/media/fridge1-before1.9156bcec.jpg";